import Vue from 'vue'
import VueRouter from 'vue-router'
import menu from '@/router/menu'
import notFound from '@/views/NotFound.vue'
Vue.use(VueRouter)

// 解决 NavigationDuplicated: Avoided redundant navigation to current location
const RouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return RouterPush.call(this, to).catch(err => err)
}

const routes = [
  {
    path: '/login',
    component: () => import('@/views/User/NewLogin.vue'),
    meta: { title: '登录', icon: 'table', name: 'login' }
  },
  {
    path: '/bigScreen',
    component: () => import('@/views/bigScreen/index.vue')
  },
  {
    path: '/bigScreenPage',
    component: () => import('@/views/bigScreenPage/index.vue')
  },
  {
    path: '/bigScreenGarden',
    component: () => import('@/views/bigScreenGarden/index.vue')
  },
  {
    path: '/home',
    component: () => import('@/views/gateway/home/index.vue')
  },
  {
    path: '/join',
    component: () => import('@/views/gateway/join/index.vue')
  },
  {
    path: '/entrust',
    component: () => import('@/views/gateway/entrust/index.vue')
  },
  {
    path: '*',
    component: notFound
  },
  /* 首页 */
  {
    path: '/',
    redirect: '/home'
  },
  ...menu
]

const router = new VueRouter({
  routes
})

export default router
